import { Colors, Lightning } from '@lightningjs/sdk';
import TextLabel from 'components/common/TextLabel';
import {
  getSeasonEpisodeFormatted,
  isExtra,
  isLiveEvent,
  isMovie,
  isSeries,
} from 'support/contentUtils';
import { getFontFaceFromStyle } from 'support/textUtils';
import { LiveEventStream, Video } from 'types/api/media';

const TITLE_FONT_SIZE = 39;
const TITLE_HEIGHT = 46;

const METADATA_FONT_SIZE = 29;
const METADATA_HEIGHT = 34;
const METADATA_TOP_PADDING = 9;

export interface VideoDetailsTemplateSpec
  extends Lightning.Component.TemplateSpec {
  mediaContent: Video | LiveEventStream | null;

  Title: typeof TextLabel;
  SubTitle: typeof TextLabel;
}

export default class VideoDetails
  extends Lightning.Component<VideoDetailsTemplateSpec>
  implements
    Lightning.Component.ImplementTemplateSpec<VideoDetailsTemplateSpec>
{
  private _mediaContent: VideoDetailsTemplateSpec['mediaContent'] = null;

  private _Title = this.getByRef('Title')!;
  private _SubTitle = this.getByRef('SubTitle')!;

  get mediaContent() {
    return this._mediaContent;
  }

  set mediaContent(mediaContent: VideoDetailsTemplateSpec['mediaContent']) {
    this._mediaContent = mediaContent;
    this.updateDetails();
  }

  get announce() {
    return [this._Title.text?.text, this._SubTitle.text?.text];
  }

  static override _template(): Lightning.Component.Template<VideoDetailsTemplateSpec> {
    return {
      Title: {
        type: TextLabel,
        text: {
          fontFace: getFontFaceFromStyle('black'),
          fontSize: TITLE_FONT_SIZE,
          textColor: Colors('text').get(),
          lineHeight: TITLE_HEIGHT,
        },
      },
      SubTitle: {
        type: TextLabel,
        y: TITLE_HEIGHT + METADATA_TOP_PADDING,
        // Season+Episode or live event subtitle
        text: {
          fontFace: getFontFaceFromStyle('medium'),
          fontSize: METADATA_FONT_SIZE,
          textColor: Colors('text').get(),
          lineHeight: METADATA_HEIGHT,
        },
      },
    };
  }

  private updateDetails() {
    let title = '';
    let description = '';
    if (!this.mediaContent) {
      // No description available
    } else if (isSeries(this.mediaContent)) {
      const isExtraOrPreview = isExtra(this.mediaContent);
      const seasonEpisodeTitle =
        getSeasonEpisodeFormatted(this.mediaContent as Video) +
        ' - ' +
        this.mediaContent?.title;
      title = isExtraOrPreview
        ? this.mediaContent?.title
        : (this.mediaContent as Video).seriesName;
      description = isExtraOrPreview ? '' : seasonEpisodeTitle;
    } else if (isLiveEvent(this.mediaContent)) {
      title = this.mediaContent?.title;
      description = (this.mediaContent as LiveEventStream).tuneIn;
    } else if (isMovie(this.mediaContent)) {
      title = this.mediaContent?.title;
    }

    this._Title.patch({ text: { text: title } });
    this._SubTitle.patch({ text: { text: description } });
  }
}
